import { cpf as CPF } from 'cpf-cnpj-validator';
import * as yup from 'yup';

export const paymentFilterSchema = yup.object().shape({
  searchString: yup
    .string()
    .nullable()
    .default('')
    .notRequired()
    .optional()
    .test('custom-cpf-validation', 'CPF inválido', (cpf) => {
      if (!cpf || cpf.trim() === '') return true;
      const cpfNumber = cpf?.replace(/[.-]/g, '');
      return CPF.isValid(cpfNumber);
    })
    .typeError('O campo CPF é obrigatório'),
});
